import React, { useEffect, useState } from "react";
import { getErrorMessage, useHttps } from "../common/http";

import API_BASE from "../config";
import UserService from "../services/user.service";
import authHeader from "../services/auth-header.js";
import { toast } from "react-hot-toast";
import { useTranslation } from "react-i18next";

const BoardAdmin = () => {
  const { t } = useTranslation();
  const [content, setContent] = useState("");
  const [users, setUsers] = useState([]);

  const [{ data: userData, error: userError, loading: userLoading }, getUsers] = useHttps(
    {
      url: API_BASE + '/api/users',
      headers: authHeader(),
    },
    {
      full: true,
    },
  )

  useEffect(() => {
    if (userError) {
      toast.error(getErrorMessage(userError))
      setUsers([])
    } else if (userData) {
      setUsers(Array.isArray(userData) ? userData : userData.data || [])
    }
  }, [userData, userError])

  useEffect(() => {
    UserService.getAdminBoard().then(
      (response) => {
        setContent(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        setContent(_content);
      }
    );
  }, []);

  return (
    <div className="container">
      <header className="jumbotron">
        <h1>{t('admin.title')}</h1>
        <h3>{content}</h3>
      </header>
      <i class="demo-icon icon-money"></i>
      <i class="demo-icon icon-spin4 animate-spin"></i>
      <div>USER: {users && JSON.stringify(users)}</div>
    </div>
  );
};

export default BoardAdmin;